import { render, staticRenderFns } from "./RBI.vue?vue&type=template&id=6c5162bd&lang=html"
import script from "./RBI.vue?vue&type=script&lang=js"
export * from "./RBI.vue?vue&type=script&lang=js"
import style0 from "./RBI.vue?vue&type=style&index=0&id=6c5162bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports